import posthog from 'posthog-js';

const posthogKey = import.meta.env.VITE_POSTHOG_KEY;
const apiHost = import.meta.env.VITE_POSTHOG_API_HOST;
const isPostHogEnabled = apiHost?.length > 0 && posthogKey?.length > 0;

const initializePostHog = () => {
  if (isPostHogEnabled) {
    posthog.init(posthogKey, {
      api_host: apiHost,
      person_profiles: 'identified_only',
      capture_pageview: true,
      capture_pageleave: true,
      opt_out_capturing_by_default: true,
    });
  }
};

export const identifyPostHogUser = (
  distinctId: string,
  properties: {
    email: string;
    name?: string;
    firstName?: string;
    lastName?: string;
    organization?: string;
    locale?: string;
    manager?: boolean;
  },
) => {
  if (isPostHogEnabled) {
    posthog.identify(distinctId, properties);
  }
};

// PostHog reset function for logout
export const resetPostHogUser = () => {
  if (isPostHogEnabled) {
    posthog.opt_out_capturing();
    posthog.reset();
  }
};

export const enablePostHogCapturing = () => {
  if (isPostHogEnabled) {
    posthog.opt_in_capturing();
  }
};

export default initializePostHog;
export { posthog };
